import Splide from '@splidejs/splide';

class ProductTeaser {

  constructor(productTeaserCarouselSelector = 'js-swa-product-teaser') {
    this.productTeaserCarouselSelector = productTeaserCarouselSelector;
  }

  init() {

    if (!this.productTeaserCarouselSelector) {
      return;
    }

    this.splideCarousel = new Splide(this.productTeaserCarouselSelector, {
      arrows: false,
      keyboard: false,
      perPage: 1
    });

    this.splideCarousel.mount();
  }

  /**
   * Used to reload the carousel in case number of items/slides has changed
   * */
  refreshCarousel() {
    this.splideCarousel.refresh();
  }

  /**
   * Selects a custom slide in the carousel
   * @param slideNumber
   */
  selectCustomSlide(slideNumber) {
    this.splideCarousel.go(slideNumber);
  }
}

export default ProductTeaser;
